import React from "react";
import HeaderTop from "../common/header/HeaderTop";
import HeaderBottomOne from "../common/header/HeaderBottomOne";
import Hero from "../components/hero/Hero";
import Feature from "../components/features/Features";
import HomeAbout from "../components/home-about/HomeAbout";
import WhyChoseUs from "../components/why-chose-us/WhyChoseUs";

import Service from "../components/sevices/Service";



import Appointment from "../components/home-appointment/Appointment";
import Footer from "../common/footer/Footer";
const Home = () => {
    return (
        <>
            <HeaderTop />
            <HeaderBottomOne />
            <Hero />
            <Feature />
            <WhyChoseUs />
            <HomeAbout />
            
            <Service />
            
            
            
            
            <Appointment />
            <Footer />
        </>
    )
}

export default Home;